module.exports = __webpack_public_path__ + "font-awesome.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/font-awesome/font-awesome.svg?v=4.7.0
// module id = ../../../../../src/fonts/font-awesome/font-awesome.svg?v=4.7.0
// module chunks = styles